import { FC, ReactElement, useState, useMemo } from 'react'
import styled from 'styled-components'
import { useSpring, animated } from '@react-spring/web'
// @ts-ignore
import { Scrollama, Step } from 'react-scrollama'

const DepakineModule: FC = (): ReactElement => {
  const [progress, setProgress] = useState(0)
  const spring = useSpring({
    translateY: progress * 100,
  })
  const [container, setContainer] = useState<HTMLDivElement | null>(null)
  const animatedIllustrations = useMemo(() => {
    return [
      [...Array(7).keys()].map(() => ({
        x: Math.random(),
        y: Math.random(),
        rotation: Math.random(),
        speed: Math.random(),
      })),
      [...Array(7).keys()].map(() => ({
        x: Math.random(),
        y: Math.random(),
        rotation: Math.random(),
        speed: Math.random() * 2,
      })),
    ]
  }, [])

  const handleWaypointEnter = () => {
    console.log('ENTER')
  }

  const handleWaypointLeave = () => {
    console.log('LEAVE')
  }

  const handleOnProgress = (e: any) => {
    setProgress(e.progress)
  }

  const containerSize = container
    ? [
        container.getBoundingClientRect().width,
        container.getBoundingClientRect().height,
      ]
    : [0, 0]

  return (
    <Scrollama
      onStepEnter={handleWaypointEnter}
      onStepExit={handleWaypointLeave}
      onStepProgress={handleOnProgress}
      offset={0.5}
    >
      <Step data={1}>
        <div>
          <Container ref={setContainer}>
            {animatedIllustrations[0].map((v, i) => {
              return (
                <Illustration
                  key={`before-${i}`}
                  x={containerSize[0] / 2 + (1 - v.x * 2) * 200}
                  y={containerSize[1] / 2 + (1 - v.y * 2) * 200}
                  style={{
                    transform: spring.translateY.to(
                      (y) =>
                        `translateY(${-y * v.speed * 10}px) rotate(${
                          330 + v.rotation * 60
                        }deg)`
                    ),
                  }}
                  src={require('./depakine-before.png')}
                  alt='Tablette de Dépakine'
                />
              )
            })}
            {animatedIllustrations[1].map((v, i) => {
              return (
                <Illustration
                  key={`after-${i}`}
                  x={containerSize[0] / 2 + (1 - v.x * 2) * 200}
                  y={
                    containerSize[1] / 2 +
                    (1 - v.y * 2) * 200 +
                    containerSize[1]
                  }
                  style={{
                    transform: spring.translateY.to(
                      (y) =>
                        `translateY(${-y * v.speed * 10}px) rotate(${
                          330 + v.rotation * 60
                        }deg)`
                    ),
                  }}
                  src={require('./depakine.png')}
                  alt='Tablette de Dépakine'
                />
              )
            })}
          </Container>
        </div>
      </Step>
    </Scrollama>
  )
}
const Container = styled.div`
  position: relative;
  background-color: #222233;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  height: 100vh;
  color: white;
  overflow: hidden;
`

const Illustration = styled(animated.img)<{ x: number; y: number }>`
  position: absolute;
  left: ${({ x }) => x}px;
  top: ${({ y }) => y}px;
  width: 250px;
  margin-left: -125px;
  margin-top: -150px;
`

export default DepakineModule
